import { Article } from "@faire/help-center-utils/articles";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
import styled from "styled-components";

import { CONTACT_CARDS_COMBINED_WIDTH } from "../consts";

import { ListOfArticles } from "./ListOfArticles";

// @ts-prune-ignore-next
export interface IHelpArticlesCardProps {
  articles: Article[];
  viewHasInstantAnswer: boolean;
  visibleWhen: boolean;
  onClickOnArticle: (articleId: string) => void;
  loadTimingRef?: React.RefCallback<HTMLElement>;
}

export const HelpArticlesCard: React.FC<IHelpArticlesCardProps> = ({
  articles,
  viewHasInstantAnswer,
  visibleWhen,
  onClickOnArticle,
  loadTimingRef,
}) => {
  if (!visibleWhen) {
    return null;
  }

  return (
    <>
      {viewHasInstantAnswer ? <Spacer height="1x" /> : null}

      <Wrapper ref={loadTimingRef}>
        <Typography variant="paragraphSansMedium">
          <StrictLocalMsg
            defaultMessage="Related articles"
            description={{
              text: "Title for the related help center articles section/card in our help center answers page",
            }}
          />
        </Typography>
        <ListOfArticles
          articles={articles}
          viewHasInstantAnswer={viewHasInstantAnswer}
          onClickOnArticle={onClickOnArticle}
        />
      </Wrapper>
      <Spacer height="3x" />
    </>
  );
};

const Wrapper = styled(Column)`
  max-width: ${CONTACT_CARDS_COMBINED_WIDTH};
  width: 100%;
  ${responsiveMediaQueries.desktopAndAbove} {
    width: ${CONTACT_CARDS_COMBINED_WIDTH};
  }
`;
